import type {TypedRequestConfig} from '@yandex-delivery/core/utils/network'
import {
  batch,
  createCorpHeadersMiddleware as withHeadersMiddleware,
  createCsrfMiddleware,
  fetchWithHeaders,
} from '@yandex-delivery/core/utils/network'
import {pipe} from '@yandex-delivery/utils'

import type {AppConfig} from '../types'

export type FetchFunction = typeof fetchWithHeaders

/**
 * TODO - сейчас в проекте три разных фетча
 * это ведет к тому, что каждый fetch имеет свою middleware со своим внутренним кэшем,
 * это ведет к тому, что будет происходить по три запроса.
 *
 * После рефакторинга, останется один fetch и этот код будет ненужен.
 * Basename должен приходить СТРОГО от сервиса, в который интегрируется
 * Временное решение, не больше
 *
 * @deprecated – Не забыть переписать при рефакторинге
 */
export const withCsrfMiddleware = (function (location: Location) {
  // В случае необходимости сюда стоит дописать basename проекта, куда интегрируется форма
  const ALLOWED_BASENAME_LIST = new Set(['account', 'order'])

  const pathnameTokens = location.pathname.split('/').filter(token => token.length > 0)

  /**
   * Первым всегда будет предполагаемый basename
   * @example у URL https://dostavka.yandex.ru/account pathname будет /account, соответственно basename будет account
   */
  const potentialBasename = pathnameTokens.at(0)
  const basename = potentialBasename && ALLOWED_BASENAME_LIST.has(potentialBasename) ? potentialBasename : undefined

  const url = basename ? `/${basename}/api/csrf_token/` : '/api/csrf_token/'

  return createCsrfMiddleware({url})
})(window.location)

function withAccountRedirectMiddleware(fetchFn: FetchFunction, accountUrl: string): FetchFunction {
  return function _withAccountRedirectMiddleware(requestConfig) {
    return fetchFn(requestConfig).catch(error => {
      if (error.status === 410) {
        window.location.href = accountUrl
        return error
      }
      throw error
    })
  }
}

export function fetch<TRequestBody, TResponseBody, TTransformedBody>(
  appConfig: AppConfig,
  config: TypedRequestConfig<TRequestBody, TResponseBody, TTransformedBody>,
) {
  const configuredFetch = pipe(
    fetchWithHeaders,
    withCsrfMiddleware,
    props => withAccountRedirectMiddleware(props, appConfig.accountUrl),
    withHeadersMiddleware({
      version: appConfig.version,
      lang: appConfig.lang,
      getURI() {
        return `${window.location.origin}${window.location.pathname}`
      },
    }),
    batch,
  ) as FetchFunction

  return configuredFetch(config)
}
